import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import './accordion.scss'

export default function Accordion(props) {
  const [collapseHeight, setCollapseHeight] = useState(0)
  const [open, setOpen] = useState(props.open)

  const toggleOpen = (e) => {
    e.preventDefault()
    setOpen(!open)

    // Used to sync ToggleStudentView component
    if (props.setStudentAccordionState) {
      props.setStudentAccordionState()
    }
  }

  const resetHeight = () => {
    setCollapseHeight(document.getElementById(`collapse-${props.title.toLowerCase().replace(' ', '-')}`).scrollHeight)
  }

  // reset Accordion height every second for 10 seconds to make sure everything is loaded
  // Cancel interval after 10 seconds, but return the interval so it can be canceled on component dismount
  const makeSureTheFreakinHeightWorks = () => {
    let count = 0
    const interval = setInterval(() => {
      resetHeight()
      if (++count == 10 && typeof window !== `undefined`) {
        window.clearInterval(interval)
      }
    }, 1000)

    return interval
  }

  useEffect(() => {
    resetHeight()
    const interval = makeSureTheFreakinHeightWorks()

    if (typeof window !== `undefined`) {
      window.addEventListener('resize', resetHeight)
      return () => {
        window.clearInterval(interval)
        window.removeEventListener('resize', resetHeight)
      }
    }
  }, [])

  return (
    <div id={`accordion-${props.title.toLowerCase().replace(' ', '-')}`} className={open ? "accordion open" : "accordion closed"}>
      <div className="card accordion-card">
        <button
          id={props.id}
          className="btn btn-link accordion-button"
          type="button"
          data-view="teacher"
          data-toggle="collapse"
          data-target={`#collapse-${props.title.toLowerCase().replace(' ', '-')}`}
          aria-expanded={open ? 'true' : 'false'}
          aria-controls={`#collapse-${props.title.toLowerCase().replace(' ', '-')}`}
          onClick={(e) => toggleOpen(e)}
        >
          <div className="d-flex">
            <div className="mr-auto">
              <h5 id={`heading-${props.title.toLowerCase().replace(' ', '-')}`} className="mb-0" style={{ lineHeight: '1.5' }}>
                { props.title }
              </h5>
            </div>
            <div className="ml-auto">
              <i className="fa fa-angle-down" />
            </div>
          </div>
        </button>
        <div
          id={`collapse-${props.title.toLowerCase().replace(' ', '-')}`}
          className="accordion-toggle"
          aria-labelledby={`#heading-${props.title.toLowerCase().replace(' ', '-')}`}
          data-parent={`#accordion-${props.title.toLowerCase().replace(' ', '-')}`}
          style={{
            maxHeight: collapseHeight !== 0 && open
            ?
            `${collapseHeight}px`
            :
            ''
          }}
        >
          <div className="card-body">
            { props.children }
          </div>
        </div>
      </div>
    </div>
  )
}

Accordion.propTypes = {
  children: PropTypes.node.isRequired,
  open : PropTypes.bool,
  setStudentAccordionState: PropTypes.function,
  title: PropTypes.string.isRequired,
}
